import {
    isThumbnailsAsideDisplayed,
    isTableOfContentsAsideDisplayed,
    isCollaborativeIndexationCreationAsideSelected,
    isCollaborativeIndexationCreationAsideDisabled,
    isCollaborativeIndexationAsideDisabled,
    getCollaborativeIndexationCreationTitle,
    isCollaborativeIndexationCreationAsideDisplayed,
    isSocialSharingAsideDisplayed,
} from '../redux/aside/selectors'
import {
    linkToCurrentMediaRecord,
    downloadOriginalMedia,
} from '../redux/currentMedia/actions'
import { toggleBookmark } from '../redux/bookmarks/actions'
import {
    isPrintPreviewOpened,
    isPrintPreviewDisabled, isDownloadDisplayed,
} from '../redux/print/selectors'
import { isDownloadMediaDisabled } from '../redux/currentMedia/selectors'
import { toggleSocialSharing } from '../redux/share/actions'
import {
    isBookmarkDisabled,
    isCollaborativeIndexationEnabled,
} from '../redux/app/selectors'
import { isTableOfContentsAsideEnabled } from '../redux/tableOfContents/selectors'
import {
    isCurrentMediaBookmarked,
    bookmarkButtonTitle,
} from '../redux/bookmarks/selectors'
import {
    areCollaborativeIndexationsDisplayed,
} from '../redux/collaborativeIndexations/selectors'
import {
    toggleCollaborativeIndexations,
    toggleCollaborativeIndexationCreation,
} from '../redux/collaborativeIndexations/actions'
import { togglePrintPreview } from '../redux/print/actions'
import { toggleThumbnailsNavigation } from '../redux/thumbnails/actions'
import { toggleTableOfContents } from '../redux/tableOfContents/actions'
import { isResponsiveModeEnabled } from '../redux/visualizer/selectors'

export const toolbars = {
    bottom: [
        [
            {
                name: 'record-link',
                action: linkToCurrentMediaRecord,
                icon: 'fa fa-external-link fa-2x',
                title: 'visualizer:toolbar.left.recordLink.button',
                isDisplayed: isResponsiveModeEnabled,
            },
            {
                name: 'download',
                action: downloadOriginalMedia,
                icon: 'fa fa-download fa-2x',
                title: 'visualizer:toolbar.left.download.button',
                isDisabled: isDownloadMediaDisabled,
                isDisplayed: isResponsiveModeEnabled,
            },
            {
                name: 'share',
                action: toggleSocialSharing,
                icon: 'fa fa-share-alt fa-2x',
                title: 'visualizer:toolbar.left.share.button',
                isSelected: isSocialSharingAsideDisplayed,
                hasAside: true,
                isDisplayed: isResponsiveModeEnabled,
            },
        ]
    ],
    left: [
        [
            {
                name: 'record-link',
                action: linkToCurrentMediaRecord,
                icon: 'fa fa-external-link fa-2x',
                title: 'visualizer:toolbar.left.recordLink.button',
            },
            {
                name: 'thumbnails',
                action: toggleThumbnailsNavigation,
                icon: 'fa fa-picture-o fa-2x',
                isSelected: isThumbnailsAsideDisplayed,
                title: 'visualizer:toolbar.left.thumbnail.button',
                hasAside: true,
            },
            {
                name: 'table-of-contents',
                action: toggleTableOfContents,
                isSelected: isTableOfContentsAsideDisplayed,
                isDisplayed: isTableOfContentsAsideEnabled,
                icon: 'fa fa-list-ol fa-2x',
                title: 'visualizer:toolbar.left.tableOfContents.button',
                hasAside: true,
            },
            {
                name: 'search',
                action: null,
                icon: 'fa fa-search fa-2x',
                title: 'visualizer:toolbar.left.search.button',
            },
        ],
        [
            {
                name: 'download',
                action: downloadOriginalMedia,
                icon: 'fa fa-download fa-2x',
                title: 'visualizer:toolbar.left.download.button',
                isDisabled: isDownloadMediaDisabled,
                isDisplayed: isDownloadDisplayed,
            },
            {
                name: 'print',
                action: togglePrintPreview,
                isSelected: isPrintPreviewOpened,
                isDisabled: isPrintPreviewDisabled,
                icon: 'fa fa-print fa-2x',
                title: 'visualizer:toolbar.left.print.button',
                hasAside: true,
            },
            {
                name: 'bookmark',
                action: toggleBookmark,
                icon: 'fa fa-star fa-2x',
                isDisabled: isBookmarkDisabled,
                isSelected: isCurrentMediaBookmarked,
                title: bookmarkButtonTitle,
            },
        ],
        [
            {
                name: 'share',
                action: toggleSocialSharing,
                icon: 'fa fa-share-alt fa-2x',
                title: 'visualizer:toolbar.left.share.button',
                isSelected: isSocialSharingAsideDisplayed,
                hasAside: true,
            },
        ],
        [
            {
                name: 'collaborativeIndexations',
                title: 'visualizer:toolbar.left.collaborativeIndexations.button',
                action: toggleCollaborativeIndexations,
                icon: 'fa fa-eye fa-2x',
                isSelected: areCollaborativeIndexationsDisplayed,
                isDisabled: isCollaborativeIndexationAsideDisabled,
                isDisplayed: isCollaborativeIndexationEnabled,
            },
            {
                name: 'collaborative-indexation-creation',
                action: toggleCollaborativeIndexationCreation,
                icon: 'nf nf-indexation nf-2x',
                title: getCollaborativeIndexationCreationTitle,
                isSelected: isCollaborativeIndexationCreationAsideSelected,
                isDisabled: isCollaborativeIndexationCreationAsideDisabled,
                isDisplayed: isCollaborativeIndexationCreationAsideDisplayed,
                hasAside: true,
            },
        ],
        [
            {
                name: 'calendar',
                action: null,
                icon: 'fa fa-calendar fa-2x',
                title: 'visualizer:toolbar.left.calendar.button',
            },
        ]
    ]
}
